<template>
  <div class="error-message" role="alert">{{ message }}</div>
</template>

<script>
export default {
  name: "LibErrorMessage",
  props: {
    message: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.error-message {
  color: rgb(179, 0, 0);
  font-size: 0.75rem;
  margin-top: 8px;
  min-height: 14px;
}
</style>
